// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2smCe","colMin":"styles_colMin__2EKxD","colCheckbox":"styles_colCheckbox__3aeTg"};